'use strict';
import angular from 'angular';
import './widget.media.directives';
import './widget.media.services';

angular.module('widget.media', [
    'widget.media.directives',
    'widget.media.services'
]);